import type { EditorCommand, EditorCommandContext } from '@/lib/editor-commands';

export interface RankedCommand {
  command: EditorCommand;
  enabled: boolean;
  score: number;
}

export function rankCommands(
  commands: readonly EditorCommand[],
  query: string,
  context: EditorCommandContext,
  recentIds: readonly string[]
): RankedCommand[] {
  const needle = normalize(query);
  return commands
    .filter((command) => command.scope === 'global' || context.surface === 'builder')
    .flatMap((command) => {
      const label = normalize(command.label);
      const keywords = command.keywords.map(normalize);
      let score = command.scope === (context.surface === 'builder' ? 'builder' : 'global') ? 250 : 0;
      if (needle) {
        if (label === needle) score += 4_000;
        else if (keywords.includes(needle)) score += 3_500;
        else if (label.startsWith(needle)) score += 2_500;
        else if (label.split(/\s+/).some((word) => word.startsWith(needle))) score += 1_500;
        else if (label.includes(needle)) score += 900;
        else if (keywords.some((keyword) => keyword.includes(needle))) score += 500;
        else return [];
      }
      const recent = recentIds.indexOf(command.id);
      if (recent >= 0) score += 400 - recent * 30;
      const enabled = command.enabled(context);
      if (enabled) score += 600;
      return [{ command, enabled, score }];
    })
    .filter((result) => needle || result.enabled)
    .sort((a, b) => b.score - a.score || a.command.category.localeCompare(b.command.category) || a.command.label.localeCompare(b.command.label))
    .slice(0, 30);
}

function normalize(value: string): string {
  return value.trim().toLocaleLowerCase();
}
